import { setData } from '#ctData';

export const setDataBeforeAsync = () => {
  // ----------- change Data
  setData({ path: 'pub.A0a.list.condList', val: false });
  // ----------- No Return
};
